import { useMutation, useQueryClient } from '@tanstack/react-query';
import { experimentalUploadEpisodeAudioFile } from '@/api';
import episodeKeys from '@/queries/episode/episodeKeys';
import camelcaseKeys from 'camelcase-keys';

const transform = (data) => {
    // TODO: Do camelcase transformation in Axios interceptor
    return camelcaseKeys(data, { deep: true });
};

const mutationFn = async ({ episodeId, audioFile }) => {
    const { data } = await experimentalUploadEpisodeAudioFile(episodeId, audioFile);

    return transform(data);
};

const useAddEpisodeAudioFileMutation = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn,
        onSuccess: (data, { episodeId }) => {
            queryClient.invalidateQueries({
                queryKey: [{ entity: 'episodeTranscriptStatus', episodeId: Number(episodeId) }],
            });
            queryClient.invalidateQueries({
                queryKey: episodeKeys.detailById(episodeId),
            });
        },
    });
};

export default useAddEpisodeAudioFileMutation;
